import type { PrivilegeTypes } from '@bringg/types';
import find from 'lodash/find';

import useStore from '../stores/helpers/use-context';

export const hasAccess = (
	currentUser: Partial<Bringg.User>,
	privilegeName?: string,
	subPrivilegeName?: string
): boolean => {
	if (!currentUser) {
		return false;
	}

	if (currentUser.admin) {
		return true;
	}

	const privilege = currentUser.authorization_flags[privilegeName];

	if (currentUser.authorization_flags && !!privilege) {
		if (subPrivilegeName) {
			const privilegeValue = privilege[subPrivilegeName];
			const defaultSubPrivilege = find(privilege.values, { field: privilege.default });

			return typeof privilegeValue === 'boolean' ? privilegeValue : defaultSubPrivilege.default;
		}
		return privilege.value;
	}

	return true;
};

export const useHasAccess = (privilegeName: PrivilegeTypes, subPrivilegeName?: string): boolean => {
	const { currentUser } = useStore();
	return hasAccess(currentUser, privilegeName, subPrivilegeName);
};
